import { FormElems } from 'components';
import { updateMandateStatusRequest } from 'containers/Mandate/redux/mandates.actions';
import { nameValueOptions } from 'utils/helperMethods';

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import PropTypes from 'prop-types';

import { Field, reduxForm } from 'redux-form';

const MandateUpdateForm = ({
    data,
    actions,
    handleSubmit,
    formData,
    isUpdating,
}) => {
    // NOTE: sending mandateProductRefId as subscriptionID, as consumed by MMS service
    const handleFormSubmit = values => {
        actions.updateMandateStatusRequest({
            ...values,
            subscriptionId: data.mandateProductRefId,
        });
    };

    return (
        <form className="refund-view" onSubmit={handleSubmit(handleFormSubmit)}>
            <div className="form-section action">
                <p className="label">Subscription Status</p>
                <div className="statusSectionComponent">
                    <Field
                        id="productState"
                        name="productState"
                        label="Please select mandate Status"
                        data={nameValueOptions(data.allowedActions)}
                        labelField="name"
                        valueField="value"
                        required
                        defaultValue={data.status}
                        component={FormElems.Select}
                    />
                </div>
                <div className="statusSectionComponent">
                    <FormElems.Button
                        buttonType="primary"
                        text="UPDATE"
                        id="submit-btn"
                        isDisable={
                            !formData ||
                            !formData.values ||
                            !formData.values.productState ||
                            isUpdating
                        }
                    />
                </div>
            </div>
        </form>
    );
};

MandateUpdateForm.propTypes = {
    data: PropTypes.object,
    mandateData: PropTypes.object,
    actions: PropTypes.object,
    formData: PropTypes.object,
    handleSubmit: PropTypes.func,
    isUpdating: PropTypes.bool,
};

const mapStateToProps = ({ auth, refundData, form }) => ({
    auth,
    refundData,
    formData: form['mandate-update-form'],
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            updateMandateStatusRequest,
        },
        dispatch
    ),
});

export default compose(
    reduxForm({
        form: 'mandate-update-form',
        enableReinitialize: true,
    }),
    connect(mapStateToProps, mapDispatchToProps)
)(MandateUpdateForm);
